import { useMemo } from 'react';
import { JSONTransformer } from '@atlaskit/editor-json-transformer';
import { ProseMirrorContentStatistics } from '@atlassian/ai-model-io/utils/prosemirror-content-statistics';
export function usePromptStatistics(_ref) {
  var userADFInput = _ref.userADFInput;
  return useMemo(function () {
    var jsonTransformer = new JSONTransformer();
    var promptStats = userADFInput ? new ProseMirrorContentStatistics(jsonTransformer.parse(userADFInput)) : undefined;
    return promptStats === null || promptStats === void 0 ? void 0 : promptStats.collectStatistics();
  }, [userADFInput]);
}